import { useQuery, UseQueryResult } from "@tanstack/react-query"
import ResponseError from "#/types/responseError"
import { carrotClient } from "#/utils/CarrotClient"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import { useFlags } from "launchdarkly-react-client-sdk"

export interface PreAuthEligibilityResponse {
  eligibleForPreAuth: boolean
}

export function usePreAuthEligibility(): UseQueryResult<PreAuthEligibilityResponse, ResponseError> {
  const { showCarrotCardCostSharePreAuth } = useFlags()
  return useQuery<PreAuthEligibilityResponse, ResponseError>(
    ["GetPreAuthEligibility"],
    async () => carrotClient.getPreAuthEligibility(),
    {
      retry: buildCarrotApiRetryPolicy(3),
      refetchOnWindowFocus: false,
      select(data) {
        return {
          eligibleForPreAuth: showCarrotCardCostSharePreAuth && data.eligibleForPreAuth
        }
      }
    }
  )
}
